__turbopack_context__.v({
  "dropdown": "pagination-module-sass-module__KqhrKG__dropdown",
  "nextBtn": "pagination-module-sass-module__KqhrKG__nextBtn",
  "pageField": "pagination-module-sass-module__KqhrKG__pageField",
  "pagination": "pagination-module-sass-module__KqhrKG__pagination",
  "prevBtn": "pagination-module-sass-module__KqhrKG__prevBtn",
});
